function getUserResponse(userResponses, questionId) {
    return userResponses.find(userResponse => userResponse.questionId === questionId);
}

function getAnswerValue(userResponses, questionId, valueMap) {
    const userResponse = getUserResponse(userResponses, questionId);

    return valueMap?.[userResponse?.id] ?? userResponse?.text;
}

function getAnswersFromSource(currentSlide, results) {
    const answerSourceId = currentSlide.props?.answerSourceId;

    if (!answerSourceId) {
        return null;
    }

    const sourceResponse = getUserResponse(results.userResponses, answerSourceId);

    return (currentSlide.props.answerPool || []).filter(answer => sourceResponse?.answerIds?.includes(answer.id));
}

export {
    getUserResponse,
    getAnswerValue,
    getAnswersFromSource
};
